/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'from-to-arrows-small-icon': {
    width: 15,
    height: 9,
    viewBox: '0 0 15 9',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.592 4.494L9 7.9 10.261 9 15 4.494 10.261 0 9 1.1l3.592 3.394zM2.408 4.506L6 1.1 4.739 0 0 4.506 4.739 9 6 7.9 2.408 4.506z" _fill="#fff"/>'
  }
})
